import { Button, IconButton, Popover, Stack, TextField, alpha } from "@mui/material";
import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import {
  getTableInputAnchorOrigin,
  getTableInputTransformOrigin,
} from "../utils";
import { colors } from "../../../utils/colors";

export const TableSearchInput = ({
  onClose,
  anchor,
  useTableDispatch,
  placeholderLabel = "Search...",
}: {
  onClose: () => void;
  anchor: HTMLElement | null;
  useTableDispatch: () => { setSearchValue: (value: string) => void; clearSearchValue: () => void };
  placeholderLabel?: string;
}) => {
  const [value, setValue] = useState<string>("");

  const anchorPosition = getTableInputAnchorOrigin();
  const transformOrigin = getTableInputTransformOrigin();
  const { setSearchValue, clearSearchValue } = useTableDispatch();

  const searchInputAdornment = (
    <IconButton
      disabled={value.length === 0}
      onClick={() => {
        setValue("");
        clearSearchValue();
      }}
    >
      {value.length === 0 ? <SearchIcon /> : <CloseIcon />}
    </IconButton>
  );

  const isValid = value.length > 0;

  return (
    <Popover
      anchorOrigin={anchorPosition}
      transformOrigin={transformOrigin}
      className="asset-table-controls-popup"
      slotProps={{
        backdrop: {
          invisible: false,
          sx: { backgroundColor: alpha(colors.navyDeep, 0.45) },
        },
      }}
      sx={{
        "& .MuiPaper-root": {
          p: 1.5,
          width: { xs: "100%", sm: "auto" },
        },
      }}
      onClose={onClose}
      anchorEl={anchor}
      open={!!anchor}
    >
      <Stack direction="row" spacing={1} alignItems="center">
        <TextField
          inputRef={(input) => input && input.focus()}
          sx={{
            flexGrow: 1,
            "& .MuiOutlinedInput-root": {
              pr: 0,
            },
          }}
          size="small"
          variant="outlined"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && isValid) {
              setSearchValue(value);
              onClose();
            }
          }}
          label={placeholderLabel}
          slotProps={{
            input: {
              endAdornment: searchInputAdornment,
            },
          }}
        />
        <Button
          disabled={!isValid}
          variant="contained"
          onClick={() => {
            setSearchValue(value);
            onClose();
          }}
        >
          Search
        </Button>
      </Stack>
    </Popover>
  );
};

export default TableSearchInput;
